<div class="space-1">
  <page-load-header *ngIf="!initialized"></page-load-header>
  <div *ngIf="initialized">

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="dropdown"><h4>A-la-carte Events</h4>
        </div>
      </div>
      <div class="col-md-6 text-right"></div>
    </div>

    <div *ngIf="events.length == 0" class="row no-gutters no-candidates">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>You have not registered for any upcoming events.</h4>
        <a [routerLink]="['/events']" class="btn btn-instagram">Register for an event</a>
      </div>
    </div>

    <ng-container *ngFor="let event of events; let idx=index">
      <div *ngIf="idx%5 == 0 " class="mt-1 mb-2">
        <ad-display [isMargin]="false"></ad-display>
      </div>
      <div class="card mb-5">
        <bxl-event-item [event]="event"></bxl-event-item>
      </div>
    </ng-container>
    <p-paginator *ngIf="events && events.length > 0" [rows]="pageSize" [first]="currentPage * pageSize" [totalRecords]="resultCount" (onPageChange)="paginate($event)" [rowsPerPageOptions]="[10, 20, 30, 50]"></p-paginator>

    <div class="py-3"></div>
  </div>
</div>

